import React from 'react';
import { useRecoilValue } from 'recoil';
import { pageLoading } from 'store/app';
import { Spinner } from 'theme-ui';

const PageSpinning = () => {
  const loading = useRecoilValue(pageLoading);

  if (!loading) {
    return null;
  }

  return (
    <div className={`fixed top-0 left-0 w-full h-full bg-grey z-9999`}>
      <div className={`absolute z-9999 top-1/2 left-1/2`}>
        <Spinner sx={{ color: '#500EC1', marginRight: 2 }} size={60} />
      </div>
    </div>
  );
};

export default PageSpinning;
